import React from "react";
import PropTypes from "prop-types";
import Button from "components/buttons";
import Icon from "components/icon";
import styles from "./styles/simple-button.css.js";
import withStyles from "components/with-styles";

const SimpleButton = ({ className, onClick, label, icon = "", classes, variant = "contained", ...props }) => (
  <div className={className}>
    <Button className={classes.button} onClick={onClick} variant={variant} color="primary" {...props}>
      {icon && <Icon name={icon} className={classes.icon} />}
      {label}
    </Button>
  </div>
);

SimpleButton.propTypes = {
  /**
   * Variante del botón
   */
  variant: PropTypes.string,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Función que se invoca al hacer clic
   */
  onClick: PropTypes.func,
  /**
   * Texto del botón
   */
  label: PropTypes.string,
  /**
   * Icono del botón (si tiene)
   */
  icon: PropTypes.string,
};

export default withStyles(styles)(SimpleButton);
